// Import JS
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
Swiper.use([Navigation]);

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
	let scrollPosition = window.scrollY;

	// Agent questions
	const agentQuestions = document.querySelectorAll("[data-agent-question]");
	agentQuestions.forEach((question) => {
		question.addEventListener("click", (e) => {
			e.preventDefault();
			window.procabAIAgent.sendUserMessage(question.dataset.agentQuestion, { openFeed: true });
		});
	});

	// Bloc agent : classe sticky une fois le hero entièrement dépassé (bas du hero au-dessus du bord haut du viewport)
	const heroBanner = document.querySelector(".hero-banner");
	const heroBannerAgent = document.querySelector(".hero-banner-agent");
	if (heroBanner && heroBannerAgent) {
		const syncHeroAgentSticky = () => {
			heroBannerAgent.classList.toggle("agent-is-sticky", heroBanner.getBoundingClientRect().bottom <= 0);
		};
		syncHeroAgentSticky();
		window.addEventListener("scroll", syncHeroAgentSticky, { passive: true });
		window.addEventListener("resize", syncHeroAgentSticky);
	}

	// Hero + logo parallax (scroll-scrubbed, même fenêtre de scroll que le hero) — desktop uniquement (≥880px, aligné sur $bp-small)
	gsap.matchMedia().add("(min-width: 880px) and (prefers-reduced-motion: no-preference)", () => {
		if (!heroBanner) {
			return;
		}
		const shift = Math.min(56, Math.max(28, window.innerHeight * 0.06));
		const scrollTriggerHero = {
			trigger: heroBanner,
			start: "top top",
			end: "bottom top",
			scrub: true,
		};

		const heroImg = heroBanner.querySelector(".hero-banner__pic img");
		if (heroImg) {
			gsap.fromTo(
				heroImg,
				{ y: -shift },
				{
					y: shift,
					ease: "none",
					scrollTrigger: { ...scrollTriggerHero },
				},
			);
		}

		const plxLogo = document.querySelector(".plx-logo");
		if (plxLogo) {
			const logoShift = shift * 0.62;
			gsap.fromTo(
				plxLogo,
				{ y: -logoShift },
				{
					y: logoShift,
					ease: "none",
					scrollTrigger: { ...scrollTriggerHero },
				},
			);
		}
	});

	// Slider promo
	const sliderPromo = document.querySelector(".slider-promo");
	if (sliderPromo) {
		const swiper = sliderPromo.querySelector(".swiper");
		const swiperPromo = new Swiper(swiper, {
			slidesPerView: 1.1,
			spaceBetween: 12,
			speed: 600,
			allowTouchMove: true,
			slidesOffsetAfter: parseFloat(getComputedStyle(document.body).getPropertyValue("--_offset-x-start")) || 0,

			breakpoints: {
				768: {
					slidesPerView: 1.7,
					spaceBetween: 32,
				},
			},
		});
	}

	// Agences (front) : slider Swiper uniquement ≤879px
	const agenciesFrontSliderRoot = document.querySelector(".agencies-front-slider");
	if (agenciesFrontSliderRoot) {
		const agenciesBreakpoint = window.matchMedia("(max-width: 879px)");
		let agenciesSwiper;

		const enableAgenciesSwiper = () => {
			agenciesSwiper = new Swiper(agenciesFrontSliderRoot, {
				slidesPerView: 1.3,
				spaceBetween: 12,
				speed: 500,
				slideClass: "swiper-mobile-slide",
				wrapperClass: "swiper-mobile-wrapper",
				slidesOffsetAfter: parseFloat(getComputedStyle(document.body).getPropertyValue("--_offset-x-start")) || 0,
			});
		};

		const agenciesBreakpointChecker = () => {
			if (agenciesBreakpoint.matches) {
				if (agenciesSwiper === undefined) {
					enableAgenciesSwiper();
				}
			} else if (agenciesSwiper !== undefined) {
				agenciesSwiper.destroy(true, true);
				agenciesSwiper = undefined;
			}
		};

		agenciesBreakpoint.addEventListener("change", agenciesBreakpointChecker);
		agenciesBreakpointChecker();
	}

	// Biens à la vente (front) : slider Swiper uniquement ≤879px
	const realEstateFrontSliderRoot = document.querySelector(".real-estate-front-slider");
	if (realEstateFrontSliderRoot) {
		const realEstateBreakpoint = window.matchMedia("(max-width: 879px)");
		let realEstateSwiper;

		const enableRealEstateSwiper = () => {
			realEstateSwiper = new Swiper(realEstateFrontSliderRoot, {
				slidesPerView: 1.3,
				spaceBetween: 12,
				speed: 500,
				slideClass: "swiper-mobile-slide",
				wrapperClass: "swiper-mobile-wrapper",
				slidesOffsetAfter: parseFloat(getComputedStyle(document.body).getPropertyValue("--_offset-x-start")) || 0,
			});
		};

		const realEstateBreakpointChecker = () => {
			if (realEstateBreakpoint.matches) {
				if (realEstateSwiper === undefined) {
					enableRealEstateSwiper();
				}
			} else if (realEstateSwiper !== undefined) {
				realEstateSwiper.destroy(true, true);
				realEstateSwiper = undefined;
			}
		};

		realEstateBreakpoint.addEventListener("change", realEstateBreakpointChecker);
		realEstateBreakpointChecker();
	}

	// Articles (front) : slider Swiper uniquement ≤879px
	const articlesFrontSliderRoot = document.querySelector(".articles-front-slider");
	if (articlesFrontSliderRoot) {
		const articlesFrontBreakpoint = window.matchMedia("(max-width: 879px)");
		let articlesFrontSwiper;

		const enableArticlesFrontSwiper = () => {
			articlesFrontSwiper = new Swiper(articlesFrontSliderRoot, {
				slidesPerView: 1.3,
				spaceBetween: 12,
				speed: 500,
				slideClass: "swiper-mobile-slide",
				wrapperClass: "swiper-mobile-wrapper",
				slidesOffsetAfter: parseFloat(getComputedStyle(document.body).getPropertyValue("--_offset-x-start")) || 0,
			});
		};

		const articlesFrontBreakpointChecker = () => {
			if (articlesFrontBreakpoint.matches) {
				if (articlesFrontSwiper === undefined) {
					enableArticlesFrontSwiper();
				}
			} else if (articlesFrontSwiper !== undefined) {
				articlesFrontSwiper.destroy(true, true);
				articlesFrontSwiper = undefined;
			}
		};

		articlesFrontBreakpoint.addEventListener("change", articlesFrontBreakpointChecker);
		articlesFrontBreakpointChecker();
	}

	// Show NewsBlock on the bottom when scrolling
	let newsBlock = document.querySelector(".bloc-news");
	let newsSticky = document.querySelector(".sticky-news");
	let minimizeNewsBlock = document.querySelector(".bloc-news__close");

	if (newsBlock) {
		window.addEventListener("scroll", () => {
			scrollPosition = window.scrollY;

			if (scrollPosition >= offset(newsBlock).top) {
				newsSticky.classList.add("is-visible");
			} else {
				newsSticky.classList.remove("is-visible");
			}
		});

		minimizeNewsBlock.addEventListener("click", (e) => {
			e.preventDefault();
			newsSticky.classList.add("is-visible");
			newsBlock.classList.add("is-hidden");
		});
	}
});
